/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Preview_Out_Of_PlanInputs */

const en_us2_search_preview_out_of_plan = /** @type {(inputs: Search_Preview_Out_Of_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not in your plan`)
};

const pt_br2_search_preview_out_of_plan = /** @type {(inputs: Search_Preview_Out_Of_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fora do seu plano`)
};

const es_419_search_preview_out_of_plan = /** @type {(inputs: Search_Preview_Out_Of_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuera de tu plan`)
};

const pt_pt2_search_preview_out_of_plan = /** @type {(inputs: Search_Preview_Out_Of_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fora do teu plano`)
};

const fr_fr2_search_preview_out_of_plan = /** @type {(inputs: Search_Preview_Out_Of_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas dans ton programme`)
};

const de_de2_search_preview_out_of_plan = /** @type {(inputs: Search_Preview_Out_Of_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht in deinem Plan`)
};

const it_it2_search_preview_out_of_plan = /** @type {(inputs: Search_Preview_Out_Of_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è nella tua scheda`)
};

/**
* | output |
* | --- |
* | "Not in your plan" |
*
* @param {Search_Preview_Out_Of_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_preview_out_of_plan = /** @type {((inputs?: Search_Preview_Out_Of_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Preview_Out_Of_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_preview_out_of_plan(inputs)
	if (locale === "es-419") return es_419_search_preview_out_of_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_search_preview_out_of_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_search_preview_out_of_plan(inputs)
	if (locale === "de-DE") return de_de2_search_preview_out_of_plan(inputs)
	if (locale === "it-IT") return it_it2_search_preview_out_of_plan(inputs)
	return en_us2_search_preview_out_of_plan(inputs)
});
export { search_preview_out_of_plan as "search.preview_out_of_plan" }